import { connect } from 'react-redux';
import {
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

function Information({
  name = '',
  isNew = false,
  disableInput = false,
  onUpdate = () => {},
}) {
  const onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    onUpdate({
      [name]: value,
    });
  };

  return (
    <Grid className="Information" spacing={2} container>
      <Grid size={12}>
        <Field
          type="text"
          label="Name"
          name="name"
          placeholder="Advertiser Name"
          value={name}
          disabled={disableInput}
          validation={{
            check: true,
            checkEmpty: !isNew,
            events: [
              'init',
              'onChange',
            ],
          }}
          testId="advertiser-name-input"
          onChange={onChange}
          required
          autoFocus
        />
      </Grid>
    </Grid>
  );
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(Information);
